// iter84.69 — extracted from pages/TournamentSetup.jsx (tech-debt sweep).
import { useState } from "react";
import { Link } from "react-router-dom";

export function DataFeedTermsModal({ feedKey, terms, onClose, onAccept }) {
    const [checked, setChecked] = useState(false);
    return (
        <div
            data-testid={`data-feed-terms-modal-${feedKey}`}
            className="fixed inset-0 z-50 bg-black/80 flex items-center justify-center p-4"
            onClick={onClose}
        >
            <div
                onClick={(e) => e.stopPropagation()}
                className="brutal-card p-6 max-w-lg w-full space-y-4 max-h-[90dvh] overflow-y-auto"
            >
                <div className="flex items-center justify-between">
                    <h3 className="font-display font-extrabold text-lg text-volt">{terms.title}</h3>
                    <button type="button" onClick={onClose} className="text-zinc-500 hover:text-white text-2xl leading-none" data-testid={`data-feed-terms-modal-${feedKey}-close`}>×</button>
                </div>
                <ul className="text-sm text-zinc-300 leading-relaxed space-y-3 list-disc pl-5">
                    {terms.body.map((t, i) => <li key={i}>{t}</li>)}
                </ul>
                <label className="flex items-start gap-2 text-xs text-zinc-300 leading-relaxed cursor-pointer pt-2 border-t border-[#222]">
                    <input
                        type="checkbox"
                        data-testid={`data-feed-terms-${feedKey}-checkbox`}
                        checked={checked}
                        onChange={(e) => setChecked(e.target.checked)}
                        className="mt-0.5 w-4 h-4 accent-cyber"
                    />
                    <span>
                        I have read and agree to the {terms.title.toLowerCase()}. I understand this
                        is the only data feed I'll use for this tournament — it cannot be changed
                        after the tournament is created.
                    </span>
                </label>
                <div className="flex justify-end gap-2 pt-2 border-t border-[#222]">
                    <button
                        type="button"
                        onClick={onClose}
                        data-testid={`data-feed-terms-${feedKey}-cancel`}
                        className="brutal-btn-ghost text-xs py-2"
                    >
                        Cancel
                    </button>
                    <button
                        type="button"
                        onClick={onAccept}
                        disabled={!checked}
                        data-testid={`data-feed-terms-${feedKey}-accept`}
                        className="brutal-btn-primary text-xs py-2 disabled:opacity-40"
                    >
                        Accept & use this feed
                    </button>
                </div>
            </div>
        </div>
    );
}

export function RedeemTrialCodeModal({ message, onClose, onRedeem }) {
    const [code, setCode] = useState("");
    const [busy, setBusy] = useState(false);
    const submit = async (e) => {
        e.preventDefault();
        if (!code.trim()) return;
        setBusy(true);
        try { await onRedeem(code.trim().toUpperCase()); }
        finally { setBusy(false); }
    };
    return (
        <div
            data-testid="redeem-trial-modal"
            className="fixed inset-0 z-50 bg-black/80 flex items-center justify-center p-4"
            onClick={onClose}
        >
            <form
                onSubmit={submit}
                onClick={(e) => e.stopPropagation()}
                className="brutal-card p-6 max-w-md w-full space-y-4"
            >
                <div className="flex items-center justify-between">
                    <h3 className="font-display font-extrabold text-lg text-volt">Have a trial code?</h3>
                    <button type="button" onClick={onClose} className="text-zinc-500 hover:text-white text-2xl leading-none">×</button>
                </div>
                <p className="text-sm text-zinc-300 leading-relaxed">{message}</p>
                {/* iter87.199.159 — Self-serve upgrade now that Paddle
                    billing is live; trial code stays as the alternative
                    path below for comped/beta rivalries. */}
                <Link
                    to="/rivalry-pro"
                    data-testid="redeem-trial-modal-pro-plus-link"
                    className="brutal-btn-primary text-xs py-2 w-full text-center block"
                >
                    Sign up for Pro+ instead
                </Link>
                <div className="flex items-center gap-2">
                    <div className="flex-1 border-t border-[#222]" />
                    <span className="text-[10px] uppercase tracking-widest text-zinc-500">or</span>
                    <div className="flex-1 border-t border-[#222]" />
                </div>
                <p className="text-[11px] text-zinc-500 leading-relaxed">
                    Or wrap up your current Tournament — Free Rivalries run one Tournament at a time.
                </p>
                <input
                    data-testid="redeem-trial-code-input"
                    value={code}
                    onChange={(e) => setCode(e.target.value.toUpperCase())}
                    placeholder="TRIAL2026"
                    className="brutal-input w-full font-mono uppercase"
                    autoFocus
                />
                <div className="flex justify-end gap-2 pt-2 border-t border-[#222]">
                    <button type="button" onClick={onClose} className="brutal-btn-ghost text-xs py-2">Cancel</button>
                    <button
                        type="submit"
                        disabled={busy || !code.trim()}
                        data-testid="redeem-trial-submit"
                        className="brutal-btn-primary text-xs py-2 disabled:opacity-60"
                    >
                        {busy ? "Redeeming…" : "Upgrade Rivalry"}
                    </button>
                </div>
            </form>
        </div>
    );
}
